// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepTimeline_timelineContainer__l8tZ0 {
  background: rgba(0, 123, 255, 0.05);
  border: 1px solid rgba(0, 123, 255, 0.2);
  border-radius: 6px;
  padding: 12px;
  margin-top: 12px;
}

.StepTimeline_timelineHeader__6fe42 {
  margin: 0 0 12px 0;
  font-size: 13px;
  color: #007BFF;
  font-weight: bold;
}

.StepTimeline_timeline__AhxGn {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.StepTimeline_timelineItem__E-qTH {
  display: flex;
  gap: 12px;
  position: relative;
  animation: StepTimeline_fadeInUp__IqbZD 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes StepTimeline_fadeInUp__IqbZD {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.StepTimeline_timelineDot__ecYKx {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.StepTimeline_dot__0p7wj {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  z-index: 1;
}

.StepTimeline_dotActive__wftQa {
  background: #007BFF;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
}

.StepTimeline_dotInactive__yddgt {
  background: #666;
  border: 2px solid #444;
}

.StepTimeline_timelineLine__MPGjV {
  width: 2px;
  height: 100%;
  background: #444;
  flex-grow: 1;
  min-height: 20px;
}

.StepTimeline_stepContent__XZUE8 {
  flex: 1 1;
  padding-bottom: 16px;
}

.StepTimeline_stepText__fNdLB {
  color: white;
  font-size: 13px;
  margin-bottom: 4px;
}

.StepTimeline_stepDate__Ch3XL {
  color: #bbb;
  font-size: 11px;
  font-style: italic;
}

.StepTimeline_stepDateMissing__6JrYO {
  color: #666;
}

.StepTimeline_noSteps__YGdHs {
  color: #bbb;
  font-size: 12px;
  text-align: center;
  padding: 8px;
}

.StepTimeline_addStepContainer__Bamzj {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 123, 255, 0.2);
}

.StepTimeline_addStepInput__9xThq {
  flex: 1 1;
  padding: 6px 10px;
  background: #23272a;
  border: 1px solid #444;
  border-radius: 4px;
  color: white;
  font-size: 12px;
}

.StepTimeline_addStepInput__9xThq:focus {
  outline: none;
  border-color: #007BFF;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

.StepTimeline_addStepButton__9DlV2 {
  padding: 6px 12px;
  background: #007BFF;
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.StepTimeline_addStepButton__9DlV2:hover:not(:disabled) {
  background: #0056b3;
}

.StepTimeline_addStepButton__9DlV2:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/StepTimeline.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,4EAAwD;AAC1D;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".timelineContainer {\r\n  background: rgba(0, 123, 255, 0.05);\r\n  border: 1px solid rgba(0, 123, 255, 0.2);\r\n  border-radius: 6px;\r\n  padding: 12px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.timelineHeader {\r\n  margin: 0 0 12px 0;\r\n  font-size: 13px;\r\n  color: #007BFF;\r\n  font-weight: bold;\r\n}\r\n\r\n.timeline {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n}\r\n\r\n.timelineItem {\r\n  display: flex;\r\n  gap: 12px;\r\n  position: relative;\r\n  animation: fadeInUp 0.35s cubic-bezier(0.22, 1, 0.36, 1);\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from { opacity: 0; transform: translateY(8px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.timelineDot {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.dotActive {\r\n  background: #007BFF;\r\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n.dotInactive {\r\n  background: #666;\r\n  border: 2px solid #444;\r\n}\r\n\r\n.timelineLine {\r\n  width: 2px;\r\n  height: 100%;\r\n  background: #444;\r\n  flex-grow: 1;\r\n  min-height: 20px;\r\n}\r\n\r\n.stepContent {\r\n  flex: 1;\r\n  padding-bottom: 16px;\r\n}\r\n\r\n.stepText {\r\n  color: white;\r\n  font-size: 13px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.stepDate {\r\n  color: #bbb;\r\n  font-size: 11px;\r\n  font-style: italic;\r\n}\r\n\r\n.stepDateMissing {\r\n  color: #666;\r\n}\r\n\r\n.noSteps {\r\n  color: #bbb;\r\n  font-size: 12px;\r\n  text-align: center;\r\n  padding: 8px;\r\n}\r\n\r\n.addStepContainer {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 12px;\r\n  padding-top: 12px;\r\n  border-top: 1px solid rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n.addStepInput {\r\n  flex: 1;\r\n  padding: 6px 10px;\r\n  background: #23272a;\r\n  border: 1px solid #444;\r\n  border-radius: 4px;\r\n  color: white;\r\n  font-size: 12px;\r\n}\r\n\r\n.addStepInput:focus {\r\n  outline: none;\r\n  border-color: #007BFF;\r\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n.addStepButton {\r\n  padding: 6px 12px;\r\n  background: #007BFF;\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: white;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.addStepButton:hover:not(:disabled) {\r\n  background: #0056b3;\r\n}\r\n\r\n.addStepButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timelineContainer": `StepTimeline_timelineContainer__l8tZ0`,
	"timelineHeader": `StepTimeline_timelineHeader__6fe42`,
	"timeline": `StepTimeline_timeline__AhxGn`,
	"timelineItem": `StepTimeline_timelineItem__E-qTH`,
	"fadeInUp": `StepTimeline_fadeInUp__IqbZD`,
	"timelineDot": `StepTimeline_timelineDot__ecYKx`,
	"dot": `StepTimeline_dot__0p7wj`,
	"dotActive": `StepTimeline_dotActive__wftQa`,
	"dotInactive": `StepTimeline_dotInactive__yddgt`,
	"timelineLine": `StepTimeline_timelineLine__MPGjV`,
	"stepContent": `StepTimeline_stepContent__XZUE8`,
	"stepText": `StepTimeline_stepText__fNdLB`,
	"stepDate": `StepTimeline_stepDate__Ch3XL`,
	"stepDateMissing": `StepTimeline_stepDateMissing__6JrYO`,
	"noSteps": `StepTimeline_noSteps__YGdHs`,
	"addStepContainer": `StepTimeline_addStepContainer__Bamzj`,
	"addStepInput": `StepTimeline_addStepInput__9xThq`,
	"addStepButton": `StepTimeline_addStepButton__9DlV2`
};
export default ___CSS_LOADER_EXPORT___;
